import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMyInsurance,
  getInsuranceList,
} from "../../features/bookings/insuranceSlice";

const InsuranceModal = ({ vals }) => {
  const { show, setShow, setModal, handleEditInsurance } = vals;
  const dispatch = useDispatch();
  const list = useSelector(getInsuranceList);
  const insuranceUpdateStatus = useSelector(
    (state) => state.insurance.insuranceUpdateStatus
  );

  React.useEffect(() => {
    let user = JSON.parse(sessionStorage.getItem("userData"));
    if (user !== null) {
      const { Authorization } = user;

      dispatch(fetchMyInsurance(Authorization));
    }
  }, [insuranceUpdateStatus]);

  return (
    <>
      <div
        className={`modal  my-auto ${show ? "d-flex" : "d-none"}`}
        id="insurance-detail"
      >
        <div className="modal-dialog modal-lg ">
          <div className="modal-content">
            <div className="modal-body ">
              <div className="cmn-form login-form ">
                <div>
                  <h2 className="mb-3">My Insurance Details</h2>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setShow(false);
                    }}
                  ></button>
                </div>
                {list.length > 0 ? (
                  list.map((val, ind) => (
                    <div className="ins-travel-wrap mb-3" key={ind}>
                      {val.status === "0" && (
                        <button
                          className="cmn-btn"
                          onClick={() => handleEditInsurance(val)}
                        >
                          {" "}
                          <i className="fas fa-pen"></i>
                        </button>
                      )}

                      <div className="row">
                        {/*  */}
                        <div className="col-lg-6">
                          <div className="travelling-details">
                            <h5>Travelling Details</h5>
                            <div className="main-wrap-travelling">
                              <div className="travellers-detail-inner">
                                <div>
                                  <p className="">User Country</p>
                                  <h6 className="mb-0">{val?.user_country}</h6>
                                </div>
                                <div>
                                  <p className="">Travel Country</p>
                                  <h6 className="mb-0">
                                    {val?.travel_country}
                                  </h6>
                                </div>
                              </div>
                              <div className="date-end-start">
                                <div>
                                  <p className="">Start Date</p>
                                  <h6 className="mb-0">
                                    {moment(val.start_date).format(
                                      `MMM Do YYYY`
                                    )}
                                  </h6>
                                </div>
                                <div>
                                  <p className="">End Date</p>
                                  <h6 className="mb-0">
                                    {" "}
                                    {moment(val.end_date).format(`MMM Do YYYY`)}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="travelling-details">
                            <h5>Travelling Details</h5>
                            <div className="transfer-detail-wrapper cmn-box flex-column">
                              <div className="d-flex align-items-start cmn-box w-100 mb-0 shadow-none p-1">
                                <div className="m-0">
                                  <img
                                    src="assets/images/user.svg"
                                    alt="call"
                                  />
                                </div>
                                <div>
                                  <div>
                                    <p>
                                      {val.nameTitle} {val.firstName}{" "}
                                      {val.lastName}
                                    </p>
                                    <p className="black-medium-12">
                                      Total passenger -{" "}
                                      <span>{val.totalPerson}</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="mail-phone-wrap w-100">
                                <div className="d-flex align-items-start cmn-box w-100 mb-0 shadow-none p-1">
                                  <div className="m-0">
                                    <img
                                      src="assets/images/call.svg"
                                      alt="call"
                                    />
                                  </div>
                                  <div>
                                    <div>
                                      <p className="black-medium-12">
                                        {" "}
                                        {val.mobile}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex align-items-start cmn-box w-100 mb-0 shadow-none p-1">
                                  <div className="m-0">
                                    <img
                                      src="assets/images/mail.svg"
                                      alt="mail"
                                    />
                                  </div>
                                  <div>
                                    <div>
                                      <p className="black-medium-12">
                                        {" "}
                                        {val.email}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {val.insurance_booking_details.map((bookD, i) => (
                          <div className="col-lg-4" key={i}>
                            <div className="travellers-wrap">
                              <p>Traveller {i + 1}</p>
                              <div className="travellers-detail">
                                <ul className="p-0 mb-0">
                                  <ul className="d-flex p-0 mb-0 justify-content-between">
                                    <li className="d-block mt-0">
                                      <p>Pre Disease :</p>
                                      <p>
                                        {parseInt(bookD.pre_disease) === 0
                                          ? "No disease"
                                          : "Yes"}
                                      </p>
                                    </li>
                                    <li className="d-block mt-0">
                                      <p>Age :</p>
                                      <p>{bookD.passanger_age}</p>
                                    </li>
                                  </ul>
                                </ul>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-insurance">
                    <img src="./assets/images/no-insurance.svg" />
                    <p className="mt-3">No Insurance to show</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InsuranceModal;
